import { Component, OnInit } from '@angular/core';
import { CrudService } from '../crud.service';
@Component({
  selector: 'app-bachelors-degree-in-business-administration',
  templateUrl: './bachelors-degree-in-business-administration.component.html',
  styleUrls: ['./bachelors-degree-in-business-administration.component.scss']
})
export class BachelorsDegreeInBusinessAdministrationComponent implements OnInit {

  constructor(private crudService: CrudService) { }
  baseUrl = this.crudService.baseUrl;

  ngOnInit(): void {
  }

}
